// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-tabs > ul > li.react-tabs__tab--selected{
    border: none !important;
    text-decoration: underline !important;
    font-weight: bold;
}

.react-tabs > ul.react-tabs__tab-list{
    border-bottom: none !important;
}

.inputStyle{
    background-color: rgba(0, 0, 0, 0.09)!important;
    border: none!important;
    color: #000;
    /* min-width: 300px !important; */
    margin: 0 10px 0 10px;
    background-color: #CCCCCC;
    font-family: 'proxima-nova';
}

.inputStyle2 {
    background-color: rgba(0, 0, 0, 0.09)!important;
    color: #000;
    /* min-width: 300px !important; */
    margin: 0 10px 0 10px;
    background-color: #CCCCCC;
    font-family: 'proxima-nova';
    width: 90% !important;
    border: 1.5px solid #b2b2b2;
}

.inputStyle3 {
    background-color: rgba(0, 0, 0, 0.09)!important;
    color: #000;
    /* min-width: 300px !important; */
    margin: 0 10px 0 40px;
    background-color: #CCCCCC;
    font-family: 'proxima-nova';
    width: 100% !important;
    border: 1.5px solid #b2b2b2;
}


.colorBlue{
    color: #3F5B7F
}

.bgColorBlue{
    background-color: #3F5B7F
}

.titleStyle{
    font-weight: bold;
    font-size: 1.2rem;
    text-transform: uppercase;
    padding: 10px 0;
}

.subtitleStyle{
    font-weight: bold;
    font-size: 1rem;
    text-transform: uppercase;
}

.chartModalTitle {
    padding-left: 15px;
}

.chartDateRangeModal {
    font-size: 14px;
    color: "#65686B"
}

.chartModalDivider {
    margin-left: 15px !important;
    margin-right: 15px !important;
    border-width: 1px !important;
    border-color: #A0A0A0;
}`, "",{"version":3,"sources":["webpack://./src/screens/historyMobile/style.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+CAA+C;IAC/C,sBAAsB;IACtB,WAAW;IACX,iCAAiC;IACjC,qBAAqB;IACrB,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,+CAA+C;IAC/C,WAAW;IACX,iCAAiC;IACjC,qBAAqB;IACrB,yBAAyB;IACzB,2BAA2B;IAC3B,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,+CAA+C;IAC/C,WAAW;IACX,iCAAiC;IACjC,qBAAqB;IACrB,yBAAyB;IACzB,2BAA2B;IAC3B,sBAAsB;IACtB,2BAA2B;AAC/B;;;AAGA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,4BAA4B;IAC5B,qBAAqB;AACzB","sourcesContent":[".react-tabs > ul > li.react-tabs__tab--selected{\n    border: none !important;\n    text-decoration: underline !important;\n    font-weight: bold;\n}\n\n.react-tabs > ul.react-tabs__tab-list{\n    border-bottom: none !important;\n}\n\n.inputStyle{\n    background-color: rgba(0, 0, 0, 0.09)!important;\n    border: none!important;\n    color: #000;\n    /* min-width: 300px !important; */\n    margin: 0 10px 0 10px;\n    background-color: #CCCCCC;\n    font-family: 'proxima-nova';\n}\n\n.inputStyle2 {\n    background-color: rgba(0, 0, 0, 0.09)!important;\n    color: #000;\n    /* min-width: 300px !important; */\n    margin: 0 10px 0 10px;\n    background-color: #CCCCCC;\n    font-family: 'proxima-nova';\n    width: 90% !important;\n    border: 1.5px solid #b2b2b2;\n}\n\n.inputStyle3 {\n    background-color: rgba(0, 0, 0, 0.09)!important;\n    color: #000;\n    /* min-width: 300px !important; */\n    margin: 0 10px 0 40px;\n    background-color: #CCCCCC;\n    font-family: 'proxima-nova';\n    width: 100% !important;\n    border: 1.5px solid #b2b2b2;\n}\n\n\n.colorBlue{\n    color: #3F5B7F\n}\n\n.bgColorBlue{\n    background-color: #3F5B7F\n}\n\n.titleStyle{\n    font-weight: bold;\n    font-size: 1.2rem;\n    text-transform: uppercase;\n    padding: 10px 0;\n}\n\n.subtitleStyle{\n    font-weight: bold;\n    font-size: 1rem;\n    text-transform: uppercase;\n}\n\n.chartModalTitle {\n    padding-left: 15px;\n}\n\n.chartDateRangeModal {\n    font-size: 14px;\n    color: \"#65686B\"\n}\n\n.chartModalDivider {\n    margin-left: 15px !important;\n    margin-right: 15px !important;\n    border-width: 1px !important;\n    border-color: #A0A0A0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
